// Shared by data-panel (autoSort reset) and presentation (showSelected lock-in) so both force the
// same sort order - state first - without duplicating the criteria object.
const autoSortCriterias: EngineAPI.ISortCriteria = {
  qSortByState: 1 as EngineAPI.TypeSortDirection,
  qSortByAscii: 1 as EngineAPI.TypeSortDirection,
  qSortByNumeric: 1 as EngineAPI.TypeSortDirection,
  qSortByLoadOrder: 1 as EngineAPI.TypeSortDirection,
};

// The image grid's "show only selected values" relies on selected/locked values sorting to the
// top (see nebula's ListBox), so sort order can't be customized away from state-first while it's on.
// layoutData (handler.layout) is preferred over itemData (properties) since properties can lag
// behind the engine-confirmed layout on rapid consecutive toggles.
export function isSortLockedToState(
  itemData?: { representation?: { type?: string; showSelected?: boolean } },
  layoutData?: { representation?: { type?: string; showSelected?: boolean } },
) {
  const representation = layoutData?.representation ?? itemData?.representation;
  return representation?.type === 'image' && !!representation?.showSelected;
}

export default autoSortCriterias;
